function checkLoggedIn($q, $timeout, $http, $location, $window, Global,$state) {
    // Initialize a new promise
    var deferred = $q.defer();
    // Make an AJAX call to check if the user is logged in
    if ($window.sessionStorage.token) {
        $http.get(api+'/api/loggedin')
            .success(function (result) {
                Global.user = result.user;
                $timeout(deferred.resolve);
                $window.sessionStorage.token = result.token;
                Global.user.settings_global.current = result.current;
            })
            .error(function (user) {
                $window.sessionStorage.token = null;
                $timeout(deferred.reject);
                $location.url('/login');
            })
    } else {
        $timeout(deferred.reject);
        $location.url('/login');
    }
    return deferred.promise;
};
checkLoggedIn.$inject = ['$q', '$timeout', '$http', '$location', '$window', 'Global', '$state'];

// Check if the user is not conntected
function checkLoggedOut($q, $timeout, $http, $location, $window, Global, $state) {
    // Initialize a new promise
    var deferred = $q.defer();
    // if there's still a token, take them back home (not login page)
    if ($window.sessionStorage.token) { // dont check if user is resetting password (passChangeToken)
        $http.get('/api/loggedin')
            .success(function (result) {
                // if success
                $timeout(deferred.reject);
                // go home
                $location.url('/live');
                $window.sessionStorage.token = result.token;
                Global.user.settings_global.current = result.current;
                console.log($state.current.url);
                if ($state.current.url === '/live') {
                    // for now if we're on the live page already, lets do a refresh
                    $window.location.reload();
                }else{
                    $location.url('/live');
                    // $window.location.reload();
                }
            })
            .error(function (user) {
                $timeout(deferred.resolve);
                $location.url('/login');
            })
    } else {
        $timeout(deferred.resolve);
    }
    return deferred.promise;
}
checkLoggedOut.$inject = ['$q', '$timeout', '$http', '$location', '$window', 'Global', '$state'];


// var bugsnag = JSON.parse(window.bugsnag);
// setting up route
function ctrl($stateProvider, $urlRouterProvider) {
    // For unmatched routes:
    $urlRouterProvider.otherwise('/live');
    // states for my app
    $stateProvider
        .state('auth', {
            template: require('../../auth/views/index.html'),
            resolve: {
                loggedout: checkLoggedOut
            }
        })
        .state('changelog', {
            template: require('../../changelog/views/index.html')
        })
        .state('landing', {
            template: require('../../landing/views/index.html'),
            controller: 'mainPageController',
            controllerAs: 'main',
            resolve: {
                loggedin: checkLoggedIn,
            }
        })
        .state('pages', {
            template: require('../../pages/views/main/main.html'),
            controller: 'mainPageController',
            controllerAs: 'main',
            resolve: {
                loggedin: checkLoggedIn,
            },
        })

}

ctrl.$inject = ['$stateProvider', '$urlRouterProvider'];
module.exports = ctrl;

// angular.module('rp.system').config(['bugsnagProvider',
//     function (bugsnagProvider) {
//         if (bugsnag.enabled) {
//             bugsnagProvider
//                 .apiKey(bugsnag.api)
//                 .releaseStage(bugsnag.env)
//                 .appVersion(JSON.parse(window.version).l3);
//         }
// }])



/** WEBPACK FOOTER **
 ** ./src/system/routes/system.js
 **/